let code = 'meubairrogestao';
let codeAPI = 'meubairro';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};